<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p v-if="screenMode.isDuplicate()" style="margin: 5px 0 15px 0">
          以下を編集してください。
        </p>

        <v-row>
          <v-col cols="6" sm="3" md="3" lg="3">
            <v-text-field
              v-if="isLaterTranslationEdit"
              :value="parseDisasterName"
              label="災害名称"
              placeholder=" "
              disabled
            >
            </v-text-field>
            <v-select
              v-else
              v-model="submitItem.disasterNo"
              :items="unfinishedDisasters"
              :rules="[rules.required]"
              label="災害名称"
              :placeholder="config.PLACEHOLDER_SELECT"
              item-text="disaster_name"
              item-value="disaster_no"
              clearable
              outlined
              @change="changeDisaster"
            >
            </v-select>
          </v-col>
          <v-col cols="6" sm="3" md="3" lg="2">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" sm="3" md="3" lg="3">
            <v-textarea
              v-if="isLaterTranslationEdit"
              :value="parsedDeliveryArea"
              label="配信先エリア"
              placeholder=" "
              readonly
              rows="3"
            >
            </v-textarea>
            <v-select
              v-else
              v-model="submitItem.deliveryArea"
              :items="municipalities"
              :rules="[rules.requiredMultiple]"
              label="配信先エリア"
              :placeholder="config.PLACEHOLDER_SELECT"
              :disabled="deliveryAreaDisabled"
              v-bind:style="{ backgroundColor: disabledDeliveryAreaColor() }"
              outlined
              multiple
              clearable
            >
            </v-select>
          </v-col>
          <v-col cols="6" sm="3" md="3" lg="3">
            <v-text-field
              v-if="isLaterTranslationEdit"
              :value="parsedDeliveryLevel"
              label="配信レベル"
              placeholder=" "
              disabled
            >
            </v-text-field>
            <v-select
              v-else
              v-model="submitItem.deliveryLevel"
              :items="deliveryLevels"
              :rules="[rules.required]"
              item-value="delivery_level"
              item-text="level_name"
              label="配信レベル"
              :placeholder="config.PLACEHOLDER_SELECT"
              @change="changeDeliveryLevel"
              outlined
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              v-if="isLaterTranslationEdit"
              v-model="submitItem.selectedLanguage"
              label="翻訳言語"
              placeholder=" "
              disabled
            >
            </v-text-field>
            <v-select
              v-else
              v-model="submitItem.selectedLanguage"
              :items="getTranslateLanguages"
              item-text="name"
              item-value="id"
              multiple
              outlined
              clearable
              label="翻訳言語選択"
              placeholder="選択してください"
              @change="changeLanguage()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <!-- select template -->
          <v-col cols="2">
            <v-btn
              @click="showTempleteDialog = true"
              class="mx-2 pt-0 mb-8"
              color="primary"
              >テンプレート選択</v-btn
            >
          </v-col>
        </v-row>
        <v-tabs v-model="selectedTab" color="black">
          <v-tab
            v-for="tab in translatelanguages"
            :key="tab.no"
            @change="changeTab(tab)"
          >
            {{ tab.name }}
          </v-tab>

          <v-tab-item v-for="tab in translatelanguages" :key="tab.no">
            <v-card :disabled="tabDisabled[tab.no]" class="v-tab-item">
              <v-row v-show="showTranslationCheck">
                <v-col cols="6" lg="2">
                  <v-checkbox
                    v-if="!laterCheckLabelFlag[tab.no]"
                    v-model="submitItem.checkTranslation[tab.no]"
                    label="後から翻訳する"
                    @change="changeTranslationCheck(tab.no)"
                  >
                  </v-checkbox>
                  <v-text-field
                    v-else
                    v-model="checkTranslationVal"
                    placeholder=" "
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="8">
                  <v-text-field
                    v-model="submitItem.deliveryTitle[tab.no]"
                    label="件名"
                    v-bind:style="{ backgroundColor: disabledColor(tab.no) }"
                    :disabled="inputDisabled[tab.no]"
                    :placeholder="config.PLACEHOLDER_INPUT"
                    v-bind="formControlProps(50)"
                    outlined
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-show="showAppCheck">
                <v-col col="6">
                  <v-checkbox
                    class="mycheckbox lowCheckBox mx-2"
                    v-model="submitItem.isPostLine"
                    label="【LINE】鹿児島県原子力防災公式アカウントへ送信"
                    @change="changeLineCheck"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row v-show="showAppCheck">
                <v-col col="6">
                  <v-checkbox
                    class="lowCheckBox mx-12"
                    v-model="submitItem.isConfirmHavingIodine"
                    label="安定ヨウ素剤所持を確認"
                    :disabled="confirmHavingIodineDisabled"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row v-show="showAppCheck">
                <v-col col="6">
                  <v-checkbox
                    class="lowCheckBox mx-2"
                    v-model="submitItem.isPostTwitter"
                    label="【Twitter】鹿児島県原子力防災公式アカウントへ送信"
                  >
                  </v-checkbox>
                  <p style="padding-left:450px;">
                    ※144文字超える場合は、文字切れして配信します。
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <!-- attaching files -->
                <v-col cols="2">
                  <div class="d-flex">
                    <v-btn
                      @click="selectUploadFile"
                      class="mx-2 mt-3"
                      color="primary"
                    >
                      ファイル添付
                    </v-btn>
                    <v-tooltip
                      right
                      :open-on-hover="false"
                      color="grey lighten-4"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          @click="on.click"
                          @blur="on.blur"
                          retain-focus-on-click
                        >
                          <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: black">
                        一度に最大10個までのファイルが登録可能です。<br />
                        ファイルサイズの合計が20Mバイト以内になるようにしてください。<br />
                        添付可能なファイルは以下の拡張子のファイルのみです。<br />
                        .png、.gif、.jpeg、.jpg、.txt、.pdf<br />
                        ※動画ファイルはアップロードできません。<br />
                      </span>
                    </v-tooltip>
                    <v-btn
                      class="mx-2 mt-3 ml-3"
                      color="primary"
                      @click="generateUrls"
                      v-if="isShowReattach()"
                      >添付ファイルURLの再貼付け</v-btn
                    >
                    <v-tooltip
                      right
                      :open-on-hover="false"
                      color="grey lighten-4"
                      v-if="isShowReattach()"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          @click="on.click"
                          @blur="on.blur"
                          retain-focus-on-click
                        >
                          <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: black">
                        本文に貼り付けられた添付ファイルのURLを誤って消した場合等、<br />
                        再度URLを貼り付ける場合は「添付ファイルURLの再貼付け」ボタンより再度貼り付けてください。<br />
                        ※「ファイル添付」ボタンを押下した場合、再度添付するファイルを選択する操作となります。<br />
                      </span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12" lg="8">
                  <v-textarea
                    v-model="submitItem.deliveryBody[tab.no]"
                    counter="1000"
                    maxlength="1000"
                    label="通知文(スマホアプリ(プッシュ通知))"
                    v-bind:style="{ backgroundColor: disabledColor(tab.no) }"
                    :placeholder="config.PLACEHOLDER_INPUT"
                    :outlined="true"
                    :disabled="inputDisabled[tab.no]"
                    :rules="[rules.required]"
                  >
                  </v-textarea>
                </v-col>
              </v-row>

              <v-card>
                <!-- preview -->
                <div style="margin: 0 0 5px 10px">
                  <p>プレビューボタンで確認の上、送信してください。</p>
                  <v-btn
                    @click="showPreview()"
                    color="primary"
                    class="mx-2 mt-3 ml-3"
                  >
                    プレビュー
                  </v-btn>
                  <v-tooltip
                    right
                    :open-on-hover="false"
                    color="grey lighten-4"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        @click="on.click"
                        @blur="on.blur"
                        retain-focus-on-click
                      >
                        <v-icon>mdi-help-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: black">
                      作成した通知を実際にユーザーが受け取る際のイメージを表示し確認できます。<br />
                      本文とURLを同じ行に記載したり同じ行にURLが2つ並ぶと、<br />
                      正常にプレビューを表示することができません。<br />
                      表示されない場合は「通知文」の欄が正しく入力されているか確認してください。<br />
                      ※プレビューが正常に表示できなくても、添付ファイル自体は正常に送信されます。<br />
                    </span>
                  </v-tooltip>
                </div>
                <br />
              </v-card>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-form>
    <p v-if="screenMode.isEdit()" style="margin: 0 0 10px 15px">
      既に日本語でプッシュ通知を送信済みの場合、翻訳した言語のみが更新されます。
    </p>

    <v-btn
      :disabled="isDisabled('SUBMIT')"
      @click="submit()"
      class="mx-2"
      color="primary"
    >
      送信
    </v-btn>
    <v-btn
      v-if="!isLaterTranslationEdit"
      :disabled="isDisabled('TEMPORARILY_SAVED')"
      @click="execute('1')"
      class="mx-2"
      color="primary"
    >
      一時保存
    </v-btn>
    <v-btn class="mx-2" color="primary" @click="onClickReturn">
      キャンセル
    </v-btn>
    <select-urls ref="selectUrls" />
    <confirm-dialog ref="confirmSubmit"></confirm-dialog>
    <v-dialog v-model="showTempleteDialog">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-toolbar dense color="white">
            <v-toolbar-title>テンプレート選択</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table
            :headers="templateHeaders"
            :items="templateItems"
            item-key="fixed_phrase_no"
            class="elevation-1 mt-2 nowrap"
            hide-default-footer
            :items-per-page="-1"
            no-data-text="テンプレートはありません。"
          >
            <template v-slot:[`item.select`]="{ item }">
              <v-btn class="mx-2" color="primary" @click="selectLanguage(item)">
                選択
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            color="primary"
            @click="showTempleteDialog = false"
            >キャンセル</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <validation-observer
      ref="fileUploadObserver"
      v-slot="fileUploadObserverProps"
    >
      <v-dialog v-model="fileUploadDialog">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-toolbar dense color="white">
              <v-toolbar-title>ファイル添付</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="addFileRow"
                :disabled="
                  editedFileItems.length > 9 || !fileUploadObserverProps.valid
                "
                >添付ファイルの追加
              </v-btn>
            </v-toolbar>
            <v-data-table
              v-model="selectedFileItems"
              :headers="filesHeaders"
              :items="editedFileItems"
              class="elevation-1 mt-2"
              locale="ja-jp"
              item-key="imageNo"
              hide-default-footer
              no-data-text="データはありません。"
            >
              <template v-slot:[`item.file`]="{ item }">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|validExtensions"
                >
                  <v-file-input
                    v-model="item.file"
                    :placeholder="config.PLACEHOLDER_FILE"
                    :accept="config.FILE_INPUT_ACCEPT"
                    :error-messages="errors"
                    prepend-icon="mdi-paperclip"
                    class="mt-2"
                    dense
                    v-bind="formControlProps()"
                    @change="changeFile(item)"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </validation-provider>
              </template>
              <template v-slot:[`item.imageTitle`]="{ item }">
                <v-text-field
                  v-model="item.imageTitle"
                  :placeholder="config.PLACEHOLDER_INPUT"
                  class="mt-2"
                  dense
                  v-bind="formControlProps(30)"
                >
                </v-text-field>
              </template>
              <template v-slot:[`item.url`]="{ item }">
                <v-text-field
                  v-model="item.url"
                  class="mt-2"
                  dense
                  outlined
                  disabled
                >
                </v-text-field>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2"
              color="primary"
              @click="uploadFiles"
              :disabled="!fileUploadObserverProps.valid"
            >
              添付
            </v-btn>
            <v-btn
              class="mx-2"
              color="primary"
              @click="fileUploadDialog = false"
            >
              キャンセル
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </validation-observer>
    <v-dialog v-model="previewDialog" max-width="950">
      <v-card>
        <v-container>
          <v-card>
            <div class="preview-content" v-html="$sanitize(previewHtml)"></div>
          </v-card>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" color="primary" @click="previewDialog = false">
            戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import Disaster from "@/plugins/disaster";
import messageUtils from "@/mixins/message-utils";
import ConfirmDialog from "@/components/ConfirmDialog";
import SelectUrls from "@/components/SelectUrls";
import config from "@/js/const";
import { arrayCount, makeRandom, nullCheck } from "@/js/utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { DisasterClass } from "@/js/value-objects/disaster-class";
import { ScreenId } from "@/js/value-objects/screen-id";
import { PushNotificationScreenMode } from "@/js/value-objects/push-notification-screen-mode";
import { PushNotificationTranslator } from "@/js/translators/pushNotificationTranslator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import sanitizeHTML from "sanitize-html";

Vue.use(Disaster);

// サニタイズ設定
// プレビュー用にimgタグを許可
sanitizeHTML.defaults.allowedTags.push("img");
sanitizeHTML.defaults.allowedAttributes.img = ["src", "style", "width"];
Vue.prototype.$sanitize = sanitizeHTML;

const disasterDeliveryDetailRepository = RepositoryFactory.get(
  "disasterDeliveryDetail"
);
const fileS3UploadRepository = RepositoryFactory.get("fileS3Upload");
const disasterStaffMstRepository = RepositoryFactory.get("disasterStaffMst");
const fileS3UrlRepository = RepositoryFactory.get("fileS3Url");

const DEFAULT_FILES = [
  {
    imageNo: 1, // ファイル連番
    imageTitle: "", // タイトル
    imageFileName: "", // イメージファイル名
    url: "",
    s3object: makeRandom(6),
    file: null, // ファイルオブジェクト
    fileUploadFlag: true // true：ファイルアップロードを実施
  }
];
const DEFAULT_DISABLED = [false, true, true, true, true];
const DEFAULT_INPUT_DISABLED = [false, false, false, false, false];
const DEFAULT_LATER_FLAG = [false, false, false, false, false];
const TRANSLATION_STATUS_NON = "0"; //未翻訳
const TRANSLATION_STATUS_DONE = "1"; //翻訳済
const TRANSLATION_STATUS_NO = "9"; //翻訳しない
const DELIVERY_STATUS_NON = "0"; //未配信
const DELIVERY_STATUS_LIVE = "1"; //配信中
const LOCALE_JA = "ja";
const LOCALE_EN = "en";
const LOCALE_KO = "ko";
const LOCALE_ZH_CN = "zh-CN";
const LOCALE_ZH_TW = "zh-TW";

export default {
  mixins: [messageUtils],
  components: {
    SelectUrls,
    ConfirmDialog,
    ValidationProvider,
    ValidationObserver,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String
  },
  data: () => ({
    overlay: false,
    screenMode: "",
    screenId: "",
    screenTitle: "",
    selectedFileItems: [],
    showReattach: false, // true：URL再貼付け表示、false：URL再貼付け非表示
    fileUploadDialog: false, // ファイル添付ダイアログのv-model
    selectedUrls: [], // 選択URL情報
    editedFileItems: [], // ファイルダイアログの編集情報
    config: config, // ファイル拡張子取得用config
    urlCreateFlag: false, // true：URL作成可能、false：URL作成不可
    detail: {}, // 災害配信情報（DB取得値）
    unfinishedDisasters: [], // 未終結の災害情報（DB取得値）
    allDisasters: [], // 全災害情報
    municipalities: [], // 配信先エリア
    fixedPhrases: [], // 定型文情報
    disasterStaff: {}, // ログインユーザ情報
    submitItem: {
      deliveryNo: "", // 配信番号
      disasterNo: "", // 災害No
      emergCls: EmergencyClass.NL, // 緊急事態区分
      disasterCls: DisasterClass.T, // 災害区分
      deliveryArea: [], // 配信エリア
      dests: [], // 配信エリアAPI送信用
      deliveryLevel: "", // 配信レベル
      selectedLanguage: [], // 翻訳言語選択
      checkTranslation: [], // 後から翻訳情報
      isPostLine: false, // 鹿児島県公式LINEアカウントへ送信
      isConfirmHavingIodine: false, // 安定ヨウ素剤所持を確認
      isPostTwitter: false, // 鹿児島県公式Twitterアカウントへ送信
      deliveryTitle: [], // 件名
      deliveryBody: [], // 通知文（プッシュ通知）
      deliveryStatus: "", // 配信ステータス
      translationStatusEn: "", //翻訳ステータス(英語)
      translationStatusKo: "", //翻訳ステータス(韓国語)
      translationStatusZhCn: "", //翻訳ステータス(中簡体)
      translationStatusZhTw: "", //翻訳ステータス(中繫体)
      attachFiles: DEFAULT_FILES, // 添付ファイル
      detachFiles: [], // 削除用ファイル（新規登録の場合は利用しない/S3側に不要なデータは残るが現在はその仕様で進めている）
      hash: "" // ハッシュ値
    },
    inputDisabled: DEFAULT_INPUT_DISABLED, // 翻訳情報活性情報（入力項目） true :非活性
    tabDisabled: DEFAULT_DISABLED, // 翻訳情報活性情報（タブ） true :非活性
    deliveryAreaDisabled: false, // 配信先エリア活性情報
    confirmHavingIodineDisabled: true, // 安定ヨウ素剤所持を確認活性情報
    fileS3Urls: [],
    deliveryLevels: [
      { delivery_level: "0", level_name: "強制配信" },
      { delivery_level: "1", level_name: "重要配信（レベル1/2設定）" },
      { delivery_level: "2", level_name: "通常配信（レベル2設定）" }
    ],
    templateItems: [],
    showTranslationCheck: false, // 後から翻訳表示フラグ（日本語タブ：非表示、日本語以外：表示）
    showAppCheck: true, // アプリチェック（LINE、Twitter）表示フラグ（日本語タブ：表示、日本語以外：非表示）
    laterCheckLabelFlag: DEFAULT_LATER_FLAG, // 後から翻訳表示切り替えフラグ（ラベル、チェックボックスを切り替える）
    translatelanguages: [
      { no: 0, name: "日本語" },
      { no: 1, name: "英語" },
      { no: 2, name: "韓国語" },
      { no: 3, name: "中国語（簡体）" },
      { no: 4, name: "中国語（繁体）" }
    ],
    selectedTab: null, // 選択しているタブ情報
    checkTranslationVal: "翻訳済み",
    showTempleteDialog: false,
    previewDialog: false,
    previewHtml: "",
    rules: {
      required: value => !!value || "必須項目です。",
      requiredMultiple: value => value.length !== 0 || "必須項目です。"
    }
  }),

  computed: {
    // ボタンの非活性制御（true：非活性、false：活性）
    isDisabled() {
      return function(buttonId) {
        let disabled = false;
        switch (buttonId) {
          case "SUBMIT":
            if (
              !this.submitItem.disasterNo ||
              (this.submitItem.deliveryLevel !== "0" &&
                this.submitItem.deliveryArea.length == 0) ||
              this.submitItem.deliveryLevel === "" ||
              !this.isInputTitleContents()
            ) {
              disabled = true;
            }
            break;
          case "TEMPORARILY_SAVED":
            if (
              !this.submitItem.disasterNo ||
              this.submitItem.deliveryLevel === ""
            ) {
              disabled = true;
            }
            break;
          default:
            break;
        }
        return disabled;
      };
    },

    // 翻訳言語選択
    getTranslateLanguages() {
      return this.translatelanguages.filter(item => item.no != "0");
    },

    // ファイルヘッダー
    filesHeaders() {
      return [
        {
          text: "ID",
          align: " d-none",
          value: "imageNo",
          sortable: false
        },
        {
          text: "ファイル",
          value: "file",
          sortable: false
        },
        {
          text: "タイトル",
          value: "imageTitle",
          sortable: false
        }
      ];
    },
    // テンプレートダイアログ
    templateHeaders() {
      return [
        {
          text: "fixed_phrase_no",
          value: "fixed_phrase_no",
          align: " d-none"
        },
        {
          text: "",
          value: "select"
        },
        {
          text: "テンプレート名称",
          value: "fixed_phrase_name",
          width: "180px"
        },
        {
          text: "緊急事態区分",
          value: "fixed_phrase_emergcls",
          align: "",
          width: "7%"
        },
        {
          text: "件名",
          value: "fixed_phrase_title",
          width: "180px"
        },
        {
          text: "本文",
          value: "fixed_phrase"
        },
        {
          text: "英語",
          value: "hasEn",
          width: "7%"
        },
        {
          value: "fixed_phrase_title_hasEn",
          align: " d-none"
        },
        {
          value: "fixed_phrase_hasEn",
          align: " d-none"
        },
        {
          text: "韓国語",
          value: "hasKo",
          width: "7%"
        },
        {
          value: "fixed_phrase_title_hasKo",
          align: " d-none"
        },
        {
          value: "fixed_phrase_hasKo",
          align: " d-none"
        },
        {
          text: "中国語(簡体)",
          value: "hasZhCn",
          width: "7%"
        },
        {
          value: "fixed_phrase_title_hasZhCn",
          align: " d-none"
        },
        {
          value: "fixed_phrase_hasZhCn",
          align: " d-none"
        },
        {
          text: "中国語(繁体)",
          value: "hasZhTw",
          width: "7%"
        },
        {
          value: "fixed_phrase_title_hasZhTw",
          align: " d-none"
        },
        {
          value: "fixed_phrase_hasZhTw",
          align: " d-none"
        }
      ];
    },
    // 災害名称（参照用）
    parseDisasterName() {
      const disasterItem = this.allDisasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },
    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    // 後から翻訳対象判定
    // 編集モードかつ未配信以外（配信済み）の場合 true
    isLaterTranslationEdit() {
      if (
        this.screenMode.isEdit() &&
        this.submitItem.deliveryStatus !== DELIVERY_STATUS_NON
      ) {
        return true;
      } else {
        return false;
      }
    },

    // 配信先エリア（参照用）
    parsedDeliveryArea() {
      const municipArray = [];
      if (!this.submitItem.deliveryArea) {
        return municipArray;
      }
      this.municipalities.forEach(obj => {
        this.submitItem.deliveryArea.forEach(municip => {
          if (obj.value === municip) {
            municipArray.push(obj.text);
          }
        });
      });
      return municipArray;
    },

    // 配信レベル
    parsedDeliveryLevel() {
      const level = this.submitItem.deliveryLevel;
      if (
        typeof level != undefined &&
        this.deliveryLevels[level] != undefined
      ) {
        return this.deliveryLevels[level].level_name;
      } else {
        return "";
      }
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(false, counter);
      };
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    // 初期化処理
    async initialize() {
      this.overlay = true;
      // モード情報の設定
      this.screenMode = PushNotificationScreenMode.factory(this.$route.name);
      this.screenId = this.screenMode.getScreenId();

      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);

      // 災害情報
      await this.$store
        .dispatch("disasterInfo/loadDisasterInfo", this.screenId)
        .then(() => {
          this.unfinishedDisasters = this.$store.state.disasterInfo.unfinished.results;
          this.allDisasters = this.$store.state.disasterInfo.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.$store.state.allArea.municipalities.forEach(municip => {
            if (municip.controlled_area == 1) {
              this.municipalities.push(municip);
            }
          });
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      if (this.screenMode.isEdit() || this.screenMode.isDuplicate()) {
        // 「編集」「コピーして編集」の場合
        // 災害配信情報
        await disasterDeliveryDetailRepository
          .list(this.screenId, this.delivery_no)
          .then(res => {
            this.detail = res.data.results[0];
          })
          .catch(e => {
            this.handleError(e, this.screenId, "evacuation-order-management");
          });
      }

      // 定型文情報
      await this.$store
        .dispatch("fixedPhrase/loadFixedPhrase", this.screenId)
        .then(() => {
          this.fixedPhrases = this.$store.state.fixedPhrase.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // ログインユーザ情報
      await disasterStaffMstRepository
        .ownList(this.screenId)
        .then(res => {
          this.disasterStaff = res.data.results[0];
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // テンプレート情報設定
      if (arrayCount(this.fixedPhrases) > 0) {
        this.fixedPhrases.forEach(fixedPhrase => {
          // プッシュ通知の配列を取得
          if (fixedPhrase.delivery_ca === "PU") {
            let isEn =
              fixedPhrase.phrases.filter(e => e.locale === LOCALE_EN).length >
              0;
            let isKo =
              fixedPhrase.phrases.filter(e => e.locale === LOCALE_KO).length >
              0;
            let isZhCN =
              fixedPhrase.phrases.filter(e => e.locale === LOCALE_ZH_CN)
                .length > 0;
            let isZhTW =
              fixedPhrase.phrases.filter(e => e.locale === LOCALE_ZH_TW)
                .length > 0;
            let pushItem = {
              fixed_phrase_name: fixedPhrase.template_name,
              fixed_phrase_emergcls: fixedPhrase.emerg_cls,
              fixed_phrase_title: fixedPhrase.phrases.filter(
                e => e.locale === LOCALE_JA
              )[0].title,
              fixed_phrase: fixedPhrase.phrases.filter(
                e => e.locale === LOCALE_JA
              )[0].phrase,
              hasEn: isEn ? "○" : "-",
              fixed_phrase_title_hasEn: isEn
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_EN)[0]
                    .title
                : "",
              fixed_phrase_hasEn: isEn
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_EN)[0]
                    .phrase
                : "",
              hasKo: isKo ? "○" : "-",
              fixed_phrase_title_hasKo: isKo
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_KO)[0]
                    .title
                : "",
              fixed_phrase_hasKo: isKo
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_KO)[0]
                    .phrase
                : "",
              hasZhCn: isZhCN ? "○" : "-",
              fixed_phrase_title_hasZhCn: isZhCN
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_ZH_CN)[0]
                    .title
                : "",
              fixed_phrase_hasZhCn: isZhCN
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_ZH_CN)[0]
                    .phrase
                : "",
              hasZhTw: isZhTW ? "○" : "-",
              fixed_phrase_title_hasZhTw: isZhTW
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_ZH_TW)[0]
                    .title
                : "",
              fixed_phrase_hasZhTw: isZhTW
                ? fixedPhrase.phrases.filter(e => e.locale === LOCALE_ZH_TW)[0]
                    .phrase
                : "",
              disp_no: fixedPhrase.disp_no
            };
            this.templateItems.push(pushItem);
          }
        });
      }
      this.submitItem.deliveryNo = this.delivery_no;
      // 災害名称テキストボックス
      this.submitItem.disasterNo = this.$disaster.disaster_no;
      // 緊急事態区分
      this.changeDisaster(this.submitItem.disasterNo);

      // 各制御初期化
      this.tabDisabled = cloneDeep(DEFAULT_DISABLED);
      this.inputDisabled = cloneDeep(DEFAULT_INPUT_DISABLED);
      this.laterCheckLabelFlag = cloneDeep(DEFAULT_LATER_FLAG);

      if (this.screenMode.isEdit() || this.screenMode.isDuplicate()) {
        /********************* 「編集」「コピーして編集」の場合 ************/
        // 災害名称テキストボックス
        this.submitItem.disasterNo = this.detail.disaster_no;
        // 緊急事態区分
        this.changeDisaster(this.submitItem.disasterNo);
        // 災害が終結していない場合
        if (!this.isUnfinished(this.submitItem.disasterNo)) {
          if (
            this.screenMode.isEdit() &&
            this.detail.delivery_status !== DELIVERY_STATUS_NON
          ) {
            const allDisasterItem = this.allDisasters.find(
              obj => obj.disaster_no === this.submitItem.disasterNo
            );
            if (allDisasterItem) {
              this.submitItem.emergCls = allDisasterItem.emerg_cls;
              this.submitItem.disasterCls = allDisasterItem.disaster_cls;
            }
          } else {
            // 災害が終結していれば災害番号は保持しない
            // 初期状態にする
            this.submitItem.disasterNo = "";
          }
        }
        // 配信先エリア
        if (arrayCount(this.detail.dests) > 0) {
          this.detail.dests.forEach(dest => {
            this.submitItem.deliveryArea.push(dest.municip_code);
          });
        }
        this.submitItem.deliveryLevel = this.detail.delivery_lev;
        this.changeDeliveryLevel(this.detail.delivery_lev);
        this.submitItem.deliveryTitle[0] = this.detail.delivery_title;
        this.submitItem.deliveryBody[0] = this.detail.delivery_body;

        // LINE、Twitter、安定ヨウ素剤チェック
        if (!this.screenMode.isDuplicate()) {
          this.submitItem.isPostLine =
            this.detail.is_post_line === "1" ? true : false;
          this.changeLineCheck(this.submitItem.isPostLine);
          this.submitItem.isConfirmHavingIodine =
            this.detail.is_confirm_having_iodine === "1" ? true : false;
          this.submitItem.isPostTwitter =
            this.detail.is_post_twitter === "1" ? true : false;
        }

        if (arrayCount(this.detail.translations) > 0) {
          this.detail.translations.forEach(translation => {
            // 英語
            if (translation.locale === LOCALE_EN) {
              this.submitItem.selectedLanguage.push(
                this.translatelanguages.filter(item => item.no === 1)[0].name
              );
              this.submitItem.deliveryTitle[1] = translation.delivery_title;
              this.submitItem.deliveryBody[1] = translation.delivery_body;
            }
            this.submitItem.checkTranslation[1] =
              this.detail.translation_status_en === TRANSLATION_STATUS_NON
                ? true
                : false;
            // 韓国語
            if (translation.locale === LOCALE_KO) {
              this.submitItem.selectedLanguage.push(
                this.translatelanguages.filter(item => item.no === 2)[0].name
              );
              this.submitItem.deliveryTitle[2] = translation.delivery_title;
              this.submitItem.deliveryBody[2] = translation.delivery_body;
            }
            this.submitItem.checkTranslation[2] =
              this.detail.translation_status_ko === TRANSLATION_STATUS_NON
                ? true
                : false;
            // 中国語(簡体)
            if (translation.locale === LOCALE_ZH_CN) {
              this.submitItem.selectedLanguage.push(
                this.translatelanguages.filter(item => item.no === 3)[0].name
              );
              this.submitItem.deliveryTitle[3] = translation.delivery_title;
              this.submitItem.deliveryBody[3] = translation.delivery_body;
            }
            this.submitItem.checkTranslation[3] =
              this.detail.translation_status_zh_cn === TRANSLATION_STATUS_NON
                ? true
                : false;
            // 中国語(繁体)
            if (translation.locale === LOCALE_ZH_TW) {
              this.submitItem.selectedLanguage.push(
                this.translatelanguages.filter(item => item.no === 4)[0].name
              );
              this.submitItem.deliveryTitle[4] = translation.delivery_title;
              this.submitItem.deliveryBody[4] = translation.delivery_body;
            }
            this.submitItem.checkTranslation[4] =
              this.detail.translation_status_zh_tw === TRANSLATION_STATUS_NON
                ? true
                : false;
          });
        }
        // 各ステータス
        this.submitItem.deliveryStatus = this.detail.delivery_status;
        this.submitItem.translationStatusEn = this.detail.translation_status_en;
        this.submitItem.translationStatusKo = this.detail.translation_status_ko;
        this.submitItem.translationStatusZhCn = this.detail.translation_status_zh_cn;
        this.submitItem.translationStatusZhTw = this.detail.translation_status_zh_tw;
        // ハッシュ値
        this.submitItem.hash = this.detail.hash;

        const attachFiles = this.detail.attach_files;
        if (arrayCount(attachFiles) > 0) {
          this.submitItem.attachFiles = attachFiles.map(attachFile => {
            const pushItem = {
              imageNo: attachFile.image_no,
              imageTitle: attachFile.image_title,
              imageFileName: attachFile.image_filename,
              url: "",
              s3object: attachFile.s3object,
              file: new File([""], attachFile.image_filename),
              fileUploadFlag: false
            };
            return pushItem;
          });

          // 短縮URL作成API呼び出し
          const s3objects = this.submitItem.attachFiles.map(
            item => item.s3object
          );
          const list = await fileS3UrlRepository
            .create(
              this.screenId,
              s3objects,
              process.env.VUE_APP_BUCKET_NAME_PUBLIC
            )
            .catch(e => {
              this.handleError(e, this.screenId, "evacuation-order-management");
            });
          this.setFileS3Urls(list);
        }
        // 言語タブはコピーして編集の場合も行う
        this.changeLanguage(); // 言語タブの活性／非活性切り替え
        /********************* 「編集」の場合 ************/
        // 編集の場合に各ステータスタブ、チェックボックスの切り替えを行う
        if (this.screenMode.isEdit()) {
          this.switchCheckLabel(); // 後から翻訳のラベル／チェック切り替え
          // 翻訳情報の入力項目の活性・非活性を切り替え
          for (
            let index = 0;
            index < this.submitItem.checkTranslation.length;
            index++
          ) {
            this.changeTranslationCheck(index);
          }
          // changeLanguageでタブの活性・非活性を初期化しているので処理順序に注意
          this.tabDisabled[0] =
            this.submitItem.deliveryStatus !== DELIVERY_STATUS_NON; // 日本語タブの本文の活性／非活性
        }
      }
      this.overlay = false;
    },

    // 件名、本文の入力判定 true：送信可能／false：送信不可
    isInputTitleContents() {
      let isSendFlg = true;
      // 件名、本文が活性で入力されていない場合
      this.translatelanguages.forEach(item => {
        if (
          !this.inputDisabled[item.no] &&
          !this.tabDisabled[item.no] &&
          (nullCheck(this.submitItem.deliveryBody[item.no]) ||
            nullCheck(this.submitItem.deliveryTitle[item.no]))
        ) {
          isSendFlg = false;
        }
      });
      return isSendFlg;
    },

    // URL選択（作成）ボタン押下時処理
    async generateUrls() {
      // temp process
      this.$refs.selectUrls.open(this.submitItem.attachFiles);
    },

    // 短縮URLの設定
    setFileS3Urls(list) {
      this.submitItem.attachFiles.forEach(item => {
        const fileS3Object = list.data.results.find(fileS3Url => {
          return fileS3Url.s3object === item.s3object;
        });
        let url = "";
        if (fileS3Object && fileS3Object.url) {
          url = fileS3Object.url;
        }
        item.url = url;
      });
    },

    // 添付ファイルURLの再貼付けボタン表示判定
    isShowReattach() {
      // アップロードファイルが存在する（初期状態でない）
      if (
        this.submitItem.attachFiles.length == 1 &&
        !this.submitItem.attachFiles[0].file
      ) {
        return false;
      } else {
        return true;
      }
    },

    // 編集用ファイルアイテムの設定
    selectUploadFile() {
      this.fileUploadDialog = true;
      this.editedFileItems = cloneDeep(this.submitItem.attachFiles);
    },
    // ファイル添付ダイアログ（設定）
    async uploadFiles() {
      this.overlay = true;
      this.fileUploadDialog = false;
      // 削除用ファイル追加
      if (
        !(
          this.submitItem.attachFiles.length == 1 &&
          !this.submitItem.attachFiles[0].file
        )
      ) {
        // DEFAULTデータのみの場合を除いたデータを対象とする
        this.submitItem.attachFiles
          .filter(attachFile => {
            // ファイルが削除or更新された場合（S3オブジェクトが一致するデータが存在しない場合）
            return !this.editedFileItems.some(file => {
              return file.s3object === attachFile.s3object;
            });
          })
          .map(filterItem => {
            this.submitItem.detachFiles.push(filterItem);
          });
      }
      const hasFiles = this.editedFileItems.some(file => {
        return file.file;
      });
      if (!hasFiles) {
        // 添付ファイルが存在しない場合
        this.submitItem.attachFiles = cloneDeep(DEFAULT_FILES);
      } else {
        // 添付ファイルが存在する場合
        this.submitItem.attachFiles = cloneDeep(this.editedFileItems);
        // ファイルアップロード処理
        await Promise.all(
          this.submitItem.attachFiles
            .filter(item => {
              return item.fileUploadFlag;
            })
            .map(async attachFile => {
              // バイナリデータ読み込み
              await this.readBinary(attachFile.file);
              // ファイルアップロードAPI呼び出し
              if (attachFile.file) {
                // s3objectに拡張子情報を追加
                const splits = attachFile.file.name.split(".");
                attachFile.s3object =
                  attachFile.s3object + "." + splits[splits.length - 1];
                const base64 = attachFile.file.binary;
                await fileS3UploadRepository.create(
                  this.screenId,
                  attachFile.s3object,
                  process.env.VUE_APP_BUCKET_NAME_PUBLIC,
                  base64
                );
              }
            })
        )
          .catch(e => {
            this.handleUpdateError(e);
          })
          .finally(() => {
            // URL作成可能に設定
            this.urlCreateFlag = true;
            // アップロードフラグをfalseに変更
            this.submitItem.attachFiles.forEach(file => {
              file.fileUploadFlag = false;
            });
          });
        if (this.urlCreateFlag) {
          // URL作成不可に設定
          this.urlCreateFlag = false;
          // 短縮URL作成API呼び出し
          const s3objects = this.submitItem.attachFiles.map(
            item => item.s3object
          );
          this.fileS3Urls = await fileS3UrlRepository
            .create(
              this.screenId,
              s3objects,
              process.env.VUE_APP_BUCKET_NAME_PUBLIC
            )
            .catch(e => {
              this.handleUpdateError(e);
            });

          // 作成したURLと添付ファイルの紐付け
          if (this.fileS3Urls) {
            this.setFileS3Urls(this.fileS3Urls);
          }
          this.submitItem.attachFiles.forEach(item => {
            // 通知文の末尾に作成URLを追加
            if (nullCheck(this.submitItem.deliveryBody[this.selectedTab])) {
              // undefinedの場合に空を設定
              this.submitItem.deliveryBody[this.selectedTab] = "";
            }
            this.submitItem.deliveryBody[this.selectedTab] += `\n${item.url}`;
          });
        }
      }
      this.showReattach = true;
      this.overlay = false;
    },
    // ファイル添付ダイアログ（削除）
    removeFile(item) {
      // アイテム削除
      const index = this.editedFileItems.indexOf(item);
      this.editedFileItems.splice(index, 1);
      // ファイルNoの採番処理（新規登録データのみ対象）
      this.resetFileNoOnlyCreate();
    },
    // ファイルNoの採番処理
    resetFileNoOnlyCreate() {
      let fileNo = 1;
      this.editedFileItems.forEach(filterItem => {
        filterItem.imageNo = fileNo;
        fileNo++;
      });
    },

    // テンプレート選択
    selectLanguage(item) {
      // 日本語
      if (!this.tabDisabled[0]) {
        this.submitItem.deliveryTitle[0] = item.fixed_phrase_title;
        this.submitItem.deliveryBody[0] = item.fixed_phrase;
      }

      // 英語
      if (
        item.hasEn === "○" &&
        !this.tabDisabled[1] &&
        !this.inputDisabled[1]
      ) {
        this.submitItem.deliveryTitle[1] = item.fixed_phrase_title_hasEn;
        this.submitItem.deliveryBody[1] = item.fixed_phrase_hasEn;
      }

      // 韓国語
      if (
        item.hasKo === "○" &&
        !this.tabDisabled[2] &&
        !this.inputDisabled[2]
      ) {
        this.submitItem.deliveryTitle[2] = item.fixed_phrase_title_hasKo;
        this.submitItem.deliveryBody[2] = item.fixed_phrase_hasKo;
      }

      // 中国語（簡体）
      if (
        item.hasZhCn === "○" &&
        !this.tabDisabled[3] &&
        !this.inputDisabled[3]
      ) {
        this.submitItem.deliveryTitle[3] = item.fixed_phrase_title_hasZhCn;
        this.submitItem.deliveryBody[3] = item.fixed_phrase_hasZhCn;
      }

      // 中国語（繁体）
      if (
        item.hasZhTw === "○" &&
        !this.tabDisabled[4] &&
        !this.inputDisabled[4]
      ) {
        this.submitItem.deliveryTitle[4] = item.fixed_phrase_title_hasZhTw;
        this.submitItem.deliveryBody[4] = item.fixed_phrase_hasZhTw;
      }
      this.showTempleteDialog = false;
      return;
    },

    // 翻訳言語選択
    changeLanguage() {
      // 初期化
      this.tabDisabled = cloneDeep(DEFAULT_DISABLED);
      // 変更された言語を活性に変更
      this.submitItem.selectedLanguage.forEach(selectedLangName => {
        let selectedObject = this.translatelanguages.find(item => {
          return item.name == selectedLangName;
        });
        let selectNo = selectedObject.no;
        this.$set(this.tabDisabled, selectNo, false);
      });
      // 入力情報クリア
      this.clearInput(this.tabDisabled);
    },

    // 配信レベル選択時
    changeDeliveryLevel(value) {
      // 強制配信時は配信先エリアを非活性にしクリア
      if (value === "0") {
        this.deliveryAreaDisabled = true;
        this.submitItem.deliveryArea = "";
        this.$refs.form.resetValidation();
      } else {
        this.deliveryAreaDisabled = false;
      }
    },

    // 後から翻訳変更時
    changeTranslationCheck(tabNo) {
      // 選択されたタブの入力項目を非活性に変更
      this.$set(
        this.inputDisabled,
        tabNo,
        this.submitItem.checkTranslation[tabNo]
      );
    },

    // 鹿児島県公式LINEアカウントへ送信変更時
    changeLineCheck(value) {
      if (value) {
        this.confirmHavingIodineDisabled = false;
      } else {
        this.confirmHavingIodineDisabled = true;
        this.submitItem.isConfirmHavingIodine = false;
      }
    },

    // 入力情報クリア
    clearInput(disabledInfo) {
      // 非活性となる項目の入力値をクリア
      for (let index = 1; index < disabledInfo.length; index++) {
        if (disabledInfo[index]) {
          this.$set(this.submitItem.checkTranslation, index, false);
          this.changeTranslationCheck(index);
          this.$set(this.submitItem.deliveryTitle, index, "");
          this.$set(this.submitItem.deliveryBody, index, "");
        }
      }
      this.$refs.form.resetValidation();
    },

    // 背景色制御
    disabledColor(tabno) {
      let backColor = "#FFFFFF";
      // 入力項目が非活性の場合にグレーに変更
      if (this.inputDisabled[tabno]) {
        backColor = "#E0E0E0";
      }
      return backColor;
    },

    // 配信先エリア非活性時の背景色
    disabledDeliveryAreaColor() {
      let backColor = "#FFFFFF";
      // 入力項目が非活性の場合にグレーに変更
      if (this.deliveryAreaDisabled) {
        backColor = "#E0E0E0";
      }
      return backColor;
    },

    // 翻訳ステータス毎のラベル、チェックボックスの表示を切り替える
    // true ：ラベル、false：チェックボックス
    switchCheckLabel() {
      // 配信ステータスが未配信以外（後から翻訳対象[配信済かつ未翻訳]の場合）
      if (this.submitItem.deliveryStatus !== DELIVERY_STATUS_NON) {
        // 英語
        if (this.submitItem.translationStatusEn === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[1] = true;
        }
        // 韓国語
        if (this.submitItem.translationStatusKo === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[2] = true;
        }
        // 中簡体
        if (this.submitItem.translationStatusZhCn === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[3] = true;
        }
        // 中繫体
        if (this.submitItem.translationStatusZhTw === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[4] = true;
        }
      }
    },

    // ファイル選択
    changeFile(item) {
      let targetItem = this.editedFileItems.find(file => {
        return file.imageNo === item.imageNo;
      });
      if (targetItem) {
        // ファイル名を設定
        if (targetItem.file) {
          targetItem.imageFileName = targetItem.file.name;
          targetItem.s3object = makeRandom(6);
          targetItem.fileUploadFlag = true;
        }
      }
    },

    // 送信ボタン押下時処理
    async submit() {
      let message = [];

      if (
        !(
          this.screenMode.isEdit() &&
          this.submitItem.deliveryStatus !== DELIVERY_STATUS_NON
        )
      ) {
        if (
          this.submitItem.isPostLine &&
          !this.submitItem.isConfirmHavingIodine &&
          !this.submitItem.isPostTwitter
        ) {
          message.push(
            "「【LINE】鹿児島県原子力防災公式アカウントへ送信」がチェックされています。"
          );
          message.push(
            "・【LINE】鹿児島県原子力防災公式アカウントへ登録されている"
          );
          message.push("　住民の方へ通知文が送信されます。");
          message.push("　");
        } else if (
          this.submitItem.isPostLine &&
          this.submitItem.isConfirmHavingIodine &&
          !this.submitItem.isPostTwitter
        ) {
          message.push("「安定ヨウ素剤所持を確認」がチェックされています。");
          message.push(
            "・【LINE】鹿児島県原子力防災公式アカウントへ登録されている"
          );
          message.push("　住民の方へ通知文が送信されます。");
          message.push("・住民が安定ヨウ素剤を持っていない場合、");
          message.push("　安定ヨウ素剤配布場所へ誘導するよう通知します。");
          message.push(
            "　安定ヨウ素剤を配布する原子力災害関係施設が確定してからチェックしてください。"
          );
          message.push("　");
        } else if (
          !this.submitItem.isPostLine &&
          !this.submitItem.isConfirmHavingIodine &&
          this.submitItem.isPostTwitter
        ) {
          message.push(
            "「【Twitter】鹿児島県原子力防災公式アカウントへ送信」がチェックされています。"
          );
          message.push(
            "・【Twitter】鹿児島県原子力防災公式アカウントへ通知文を投稿します。"
          );
          message.push("　");
        } else if (
          this.submitItem.isPostLine &&
          !this.submitItem.isConfirmHavingIodine &&
          this.submitItem.isPostTwitter
        ) {
          message.push(
            "「【LINE】鹿児島県原子力防災公式アカウントへ送信」および、"
          );
          message.push(
            "「【Twitter】鹿児島県原子力防災公式アカウントへ送信」がチェックされています。"
          );
          message.push(
            "・【LINE】鹿児島県原子力防災公式アカウントへ登録されている"
          );
          message.push("　住民の方へ通知文が送信されます。");
          message.push(
            "・【Twitter】鹿児島県原子力防災公式アカウントへ通知文を投稿します。"
          );
          message.push("　");
        } else if (
          this.submitItem.isPostLine &&
          this.submitItem.isConfirmHavingIodine &&
          this.submitItem.isPostTwitter
        ) {
          message.push(
            "「【LINE】鹿児島県原子力防災公式アカウントへ送信」および、"
          );
          message.push("「安定ヨウ素剤所持を確認」、");
          message.push(
            "「【Twitter】鹿児島県原子力防災公式アカウントへ送信」がチェックされています。"
          );
          message.push(
            "・【LINE】鹿児島県原子力防災公式アカウントへ登録されている"
          );
          message.push("　住民の方へ通知文が送信されます。");
          message.push("・住民が安定ヨウ素剤を持っていない場合、");
          message.push("　安定ヨウ素剤配布場所へ誘導するよう通知します。");
          message.push(
            "　安定ヨウ素剤を配布する原子力災害関係施設が確定してからチェックしてください。"
          );
          message.push(
            "・【Twitter】鹿児島県原子力防災公式アカウントへ通知文を投稿します。"
          );
          message.push("　");
        }
      }
      if (this.isNotArea()) {
        message.push(
          "送信先に所属市町村以外のエリアも選択されています。送信してもよろしいですか?"
        );
      } else {
        message.push("送信してもよろしいですか?");
      }
      const result = await this.$refs.confirmSubmit.open(message, "送信", {
        color: "primary",
        width: 490
      });
      if (!result) {
        return;
      }
      this.execute();
    },

    // 送信・一時保存処理
    async execute(temporarilySaved = "0") {
      this.overlay = true;
      if (this.screenMode.isDuplicate() || this.screenMode.isCreate()) {
        //「新規登録」「コピーして編集」の場合
        // 登録処理
        this.submitItem.deliveryStatus =
          temporarilySaved === "1" ? DELIVERY_STATUS_NON : DELIVERY_STATUS_LIVE; // 配信ステータス判定
        this.executeCreateApi();
      } else if (
        this.screenMode.isEdit() &&
        this.submitItem.deliveryStatus === DELIVERY_STATUS_NON
      ) {
        //「編集」（未配信）の場合
        // 更新処理
        this.submitItem.deliveryStatus =
          temporarilySaved === "1" ? DELIVERY_STATUS_NON : DELIVERY_STATUS_LIVE; // 配信ステータス判定
        this.executeUpdateApi();
      } else if (
        this.screenMode.isEdit() &&
        this.submitItem.deliveryStatus !== DELIVERY_STATUS_NON
      ) {
        //「編集」（配信済）の場合
        // 翻訳処理
        this.executeTranslateApi();
      }
      this.overlay = false;
    },

    // キャンセルボタン押下時処理
    onClickReturn() {
      this.$router.push("/evacuation-order");
    },

    // 登録処理
    async executeCreateApi() {
      // API実行前処理
      // 入力情報をAPI形式に変換
      const attachFiles = this.getConvertApiFiles(this.submitItem.attachFiles); // 添付ファイル情報
      this.setTranslationStatus(); // 翻訳ステータス判定
      const translations = this.getConvertApiUpdTranslation(this.submitItem); // 翻訳情報
      this.$delete(translations, "image_no"); // ファイル連番は削除
      this.setDests();
      let payload = PushNotificationTranslator.toCreatePayload(
        this.submitItem,
        attachFiles,
        translations
      );
      this.deleteItem(payload); // 不要項目削除（1件も存在しない場合はキー自体設定しない）
      this.clearMessage();

      // 登録API呼び出し
      await disasterDeliveryDetailRepository
        .create(ScreenId.SF0305, payload)
        .then(response => {
          this.handleSuccess(response, "evacuation-order-management");
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });
    },

    // 更新処理
    async executeUpdateApi() {
      // API実行前処理
      // 入力情報をAPI形式に変換
      const attachFiles = this.getConvertApiFiles(
        this.getDiffAttachFiles(this.submitItem.attachFiles)
      );
      const detachFiles = this.getDetachFiles(this.submitItem.detachFiles);
      this.setTranslationStatus(); // 翻訳ステータス判定
      const translations = this.getConvertApiUpdTranslation(this.submitItem); // 翻訳情報
      this.setDests();
      let payload = PushNotificationTranslator.toUpdatePayload(
        this.submitItem,
        attachFiles,
        detachFiles,
        translations
      );
      this.deleteItem(payload); // 不要項目削除（1件も存在しない場合はキー自体設定しない）
      this.clearMessage();

      // 更新API呼び出し
      await disasterDeliveryDetailRepository
        .update(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response, "evacuation-order-management");
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });
    },

    // 翻訳処理
    async executeTranslateApi() {
      // 翻訳API呼び出し
      this.setTranslationStatus(); // 翻訳ステータス判定
      const translations = this.getConvertApiTranslation(this.submitItem); // 翻訳情報
      const payload = PushNotificationTranslator.toTranslationPayload(
        this.submitItem,
        translations
      );
      this.clearMessage();
      await disasterDeliveryDetailRepository
        .translate(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response, "evacuation-order-management");
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });
    },

    // 添付ファイル情報取得処理
    getDiffAttachFiles(attachFiles) {
      let diffAttachFiles = [];
      if (!this.isExistFiles(attachFiles)) {
        return diffAttachFiles;
      }
      // 「編集」の場合（初期表示からの追加分を添付ファイル情報とする）
      diffAttachFiles = attachFiles.filter(attachFile => {
        if (
          this.detail &&
          this.detail.attach_files &&
          this.detail.attach_files.length > 0
        ) {
          // 初期表示時との差分のみに絞る
          return !this.detail.attach_files.some(file => {
            return file.s3object === attachFile.s3object;
          });
        }
        return true;
      });
      return diffAttachFiles;
    },

    // 添付ファイル情報取得処理
    // true 添付ファイルあり/ false 添付ファイルなし
    isExistFiles(attachFiles) {
      let isExistFiles = false;
      if (attachFiles.length >= 1) {
        // 添付ファイル数が1以上の場合 かつ
        // 添付ファイル数が1で空でない場合に添付ファイルありと判定
        if (!(attachFiles.length == 1 && !attachFiles[0].file)) {
          isExistFiles = true;
        }
      }
      return isExistFiles;
    },

    // APIリクエストの形式にファイル変換した添付ファイル情報取得
    getConvertApiFiles(attachFiles) {
      let apiAttachFiles = [];
      if (!this.isExistFiles(attachFiles)) {
        return apiAttachFiles;
      }
      // APIリクエストの形式に変換
      apiAttachFiles = attachFiles.map(item => {
        let mapItem = {};
        if (!nullCheck(item.imageNo)) {
          // ファイル連番
          mapItem.image_no = item.imageNo;
        }
        if (!nullCheck(item.imageTitle)) {
          // タイトル
          mapItem.image_title = item.imageTitle;
        }
        if (!nullCheck(item.imageFileName)) {
          // イメージファイル名
          mapItem.image_filename = item.imageFileName;
        }
        if (!nullCheck(item.s3object)) {
          // s3オブジェクト
          mapItem.s3object = item.s3object;
        }
        return mapItem;
      });
      return apiAttachFiles;
    },

    // APIリクエストの形式変換した削除ファイル情報取得
    getDetachFiles(detachFiles) {
      let apiDetachFiles = [];
      if (
        this.detail &&
        this.detail.attach_files &&
        this.detail.attach_files.length > 0
      ) {
        apiDetachFiles = detachFiles
          .filter(detachFile => {
            return this.detail.attach_files.some(file => {
              return file.s3object === detachFile.s3object;
            });
          })
          .map(filterItem => {
            const targetItem = this.detail.attach_files.find(file => {
              return file.s3object === filterItem.s3object;
            });
            let mapItem = {
              image_no: targetItem.image_no
            };
            return mapItem;
          });
      }
      return apiDetachFiles;
    },

    // 登録・更新API用翻訳情報変換
    getConvertApiUpdTranslation(item) {
      const selectedLanguage = [];
      if (item.translationStatusEn !== TRANSLATION_STATUS_NO) {
        selectedLanguage.push({
          locale: LOCALE_EN,
          delivery_title: item.deliveryTitle[1] ? item.deliveryTitle[1] : "",
          delivery_body: item.deliveryBody[1] ? item.deliveryBody[1] : ""
        });
      }
      if (item.translationStatusKo !== TRANSLATION_STATUS_NO) {
        selectedLanguage.push({
          locale: LOCALE_KO,
          delivery_title: item.deliveryTitle[2] ? item.deliveryTitle[2] : "",
          delivery_body: item.deliveryBody[2] ? item.deliveryBody[2] : ""
        });
      }
      if (item.translationStatusZhCn !== TRANSLATION_STATUS_NO) {
        selectedLanguage.push({
          locale: LOCALE_ZH_CN,
          delivery_title: item.deliveryTitle[3] ? item.deliveryTitle[3] : "",
          delivery_body: item.deliveryBody[3] ? item.deliveryBody[3] : ""
        });
      }
      if (item.translationStatusZhTw !== TRANSLATION_STATUS_NO) {
        selectedLanguage.push({
          locale: LOCALE_ZH_TW,
          delivery_title: item.deliveryTitle[4] ? item.deliveryTitle[4] : "",
          delivery_body: item.deliveryBody[4] ? item.deliveryBody[4] : ""
        });
      }
      return selectedLanguage;
    },

    // 翻訳API用翻訳情報変換
    getConvertApiTranslation(item) {
      const selectedLanguage = [];
      // 翻訳済みの場合のみ送信
      if (item.translationStatusEn === TRANSLATION_STATUS_DONE) {
        selectedLanguage.push({
          status: item.translationStatusEn,
          locale: LOCALE_EN,
          delivery_title: item.deliveryTitle[1],
          delivery_body: item.deliveryBody[1]
        });
      }
      if (item.translationStatusKo === TRANSLATION_STATUS_DONE) {
        selectedLanguage.push({
          status: item.translationStatusKo,
          locale: LOCALE_KO,
          delivery_title: item.deliveryTitle[2],
          delivery_body: item.deliveryBody[2]
        });
      }
      if (item.translationStatusZhCn === TRANSLATION_STATUS_DONE) {
        selectedLanguage.push({
          status: item.translationStatusZhCn,
          locale: LOCALE_ZH_CN,
          delivery_title: item.deliveryTitle[3],
          delivery_body: item.deliveryBody[3]
        });
      }
      if (item.translationStatusZhTw === TRANSLATION_STATUS_DONE) {
        selectedLanguage.push({
          status: item.translationStatusZhTw,
          locale: LOCALE_ZH_TW,
          delivery_title: item.deliveryTitle[4],
          delivery_body: item.deliveryBody[4]
        });
      }
      return selectedLanguage;
    },

    // 配信先エリア判定 対象外に配信先エリアを含む true
    isNotArea() {
      let isNotAreaFlg = false;
      // 配信レベルが強制配信の場合は全エリアに送信する
      if (this.submitItem.deliveryLevel === "0") {
        return isNotAreaFlg;
      }
      this.submitItem.deliveryArea.forEach(area => {
        if (area !== this.disasterStaff.municip_code) {
          isNotAreaFlg = true;
        }
      });
      return isNotAreaFlg;
    },

    // ファイル添付ダイアログ（添付ファイルの追加）
    addFileRow() {
      this.editedFileItems.push({
        imageNo: null, // ファイル連番（ItemKeyの重複を避けるためnullを設定）
        imageTitle: "", // タイトル
        imageFileName: "", // イメージファイル名
        url: "", // ダウンロードURL
        file: null, // ファイルオブジェクト
        fileUploadFlag: true // true：ファイルアップロードを実施
      });
      // ファイルNoの採番処理（新規登録データのみ対象）
      this.resetFileNoOnlyCreate();
    },

    // 災害名称セレクトボックス変更時
    changeDisaster(value) {
      const disasterItem = this.unfinishedDisasters.find(
        obj => obj.disaster_no === value
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
        this.submitItem.disasterCls = disasterItem.disaster_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
        this.submitItem.disasterCls = DisasterClass.T;
      }
    },

    // 未終結災害判定
    isUnfinished(disasterNo) {
      const disasterItem = this.unfinishedDisasters.find(
        obj => obj.disaster_no === disasterNo
      );
      if (disasterItem) {
        return true;
      } else {
        return false;
      }
    },

    // プレビューダイアログ表示
    showPreview() {
      this.previewDialog = true;
      this.parseContents(this.submitItem.deliveryBody[this.selectedTab]);
    },

    // プレビュー表示処理
    parseContents(content) {
      const lines = content.toString().split("\n");
      let parsed = "";
      for (let index = 0; index < lines.length; index++) {
        const pattern = /^http.*(.png|.jpeg|.jpg)$/i;
        if (pattern.test(lines[index])) {
          const image =
            `<img src="` +
            lines[index] +
            `" alt="picture" style="width:50%; height:auto;"><br>`;
          parsed += image;
        } else {
          const html = `<p>${lines[index]}</p>`;
          parsed += html;
        }
      }
      this.previewHtml = parsed;
    },

    // バイナリデータ作成
    readBinary(file) {
      return new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener("load", e => {
          file.binary = e.target.result.replace(/data:.*\/.*;base64,/, "");
          resolve();
        });
      });
    },

    // 翻訳ステータス設定
    setTranslationStatus() {
      this.translatelanguages.forEach(item => {
        let checkLater = this.submitItem.checkTranslation[item.no];
        let isNotSelectd = this.tabDisabled[item.no];
        // 英語
        if (item.no === 1) {
          this.submitItem.translationStatusEn = this.getTranslationStatus(
            checkLater,
            isNotSelectd
          );
          // 韓国語
        } else if (item.no === 2) {
          this.submitItem.translationStatusKo = this.getTranslationStatus(
            checkLater,
            isNotSelectd
          );
          // 中簡体
        } else if (item.no === 3) {
          this.submitItem.translationStatusZhCn = this.getTranslationStatus(
            checkLater,
            isNotSelectd
          );
          // 中繫体
        } else if (item.no === 4) {
          this.submitItem.translationStatusZhTw = this.getTranslationStatus(
            checkLater,
            isNotSelectd
          );
        }
      });
    },

    // 配信先エリア設定（API形式に変換）
    setDests() {
      if (arrayCount(this.submitItem.deliveryArea) > 0) {
        this.submitItem.deliveryArea.forEach(item => {
          let mapItem = {
            municip_code: item
          };
          this.submitItem.dests.push(mapItem);
        });
      }
    },

    // 不要項目削除（1件も存在しない場合はキー自体設定しない）
    deleteItem(payloadItem) {
      // 配信先エリアが空の場合はキー項目削除
      if (payloadItem.dests.length === 0) {
        this.$delete(payloadItem, "dests");
      }
      // 翻訳選択情報が空の場合はキー項目削除
      if (payloadItem.translations.length === 0) {
        this.$delete(payloadItem, "translations");
      }
      // 添付ファイル情報が空の場合はキー項目削除
      if (payloadItem.attach_files.length === 0) {
        this.$delete(payloadItem, "attach_files");
      }
      // 削除ファイル情報が空の場合はキー項目削除
      // 削除ファイル情報は編集のみ
      if (this.screenMode.isEdit()) {
        if (payloadItem.detach_files.length === 0) {
          this.$delete(payloadItem, "detach_files");
        }
      }
    },

    // 翻訳済みの判定処理
    // @param checkTranslation true 後から翻訳するチェック／false 後から翻訳する未チェック
    // @param isNotSelectd true 対象タブ未選択／false 対象タブ選択
    getTranslationStatus(checkTranslation, isNotSelectd) {
      if (isNotSelectd) {
        return TRANSLATION_STATUS_NO; // 翻訳しない
      } else {
        // 後から翻訳するチェックの場合 : 未翻訳
        // 後から翻訳する未チェックの場合 : 翻訳済
        return checkTranslation
          ? TRANSLATION_STATUS_NON
          : TRANSLATION_STATUS_DONE;
      }
    },

    // タブ選択時の後から翻訳の表示判定
    changeTab(tab) {
      if (tab.no == 0) {
        this.showTranslationCheck = false;
        this.showAppCheck = true;
      } else {
        this.showTranslationCheck = true;
        this.showAppCheck = false;
      }
    }
  },

  watch: {
    selectedUrls: {
      immediate: true,
      handler: function(value) {
        if (value && Array.isArray(value) && value.length > 0) {
          value.forEach(selectedurl => {
            let tempbody = (this.submitItem.deliveryBody[
              this.selectedTab
            ] += `\n${selectedurl.url}`);
            this.$set(this.submitItem.deliveryBody, this.selectedTab, tempbody);
          });
          if (this.submitItem.deliveryBody[this.selectedTab].length > 1000) {
            this.submitItem.deliveryBody[
              this.selectedTab
            ] = this.submitItem.deliveryBody.substr(0, 1000);
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.v-tab-item {
  padding: 10px;
}

.v-tab {
  background-color: #dcdcdc;
  color: black;
}

.list-file-name {
  color: black;
}

.preview-content {
  margin: 10px;
  padding: 10px;
  display: inline-block;
}

.lowCheckBox {
  height: 0;
  padding: 3;
  margin: 1;
}
</style>
